import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "messaging-layout page-layout" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "page-header mx-2" }, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "page-content list-section position-relative h-100 mx-2" }
const _hoisted_4 = {
  key: 0,
  id: "Patient_Section"
}
const _hoisted_5 = { class: "row-span-2 h-100 p-0" }
const _hoisted_6 = {
  key: 0,
  class: "row-span-2 h-100"
}
const _hoisted_7 = {
  key: 1,
  class: "row-span-2 h-100"
}
const _hoisted_8 = {
  key: 1,
  class: "banner-container pb-2"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_PatientList = _resolveComponent("PatientList")!
  const _component_EmployeeList = _resolveComponent("EmployeeList")!
  const _component_ChatTutorial = _resolveComponent("ChatTutorial")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", {
        class: _normalizeClass(`card w-100 h-100 ${_ctx.showBanner ? 'custom-banner-padding' : 'pb-3'}`)
      }, [
        _createVNode(_component_router_view)
      ], 2 /* CLASS */),
      (_ctx.showPatients || _ctx.showEmployees)
        ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.showPatients)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_PatientList, {
                      showPatients: _ctx.showPatients,
                      "onUpdate:showPatients": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showPatients) = $event))
                    }, null, 8 /* PROPS */, ["showPatients"])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.showEmployees)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_EmployeeList, {
                      showEmployees: _ctx.showEmployees,
                      "onUpdate:showEmployees": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showEmployees) = $event))
                    }, null, 8 /* PROPS */, ["showEmployees"])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.showBanner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("a", {
              href: _ctx.banner.link,
              target: "_blank",
              rel: "noopener noreferrer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addLog(_ctx.banner)))
            }, [
              _createElementVNode("img", {
                src: _ctx.banner.src,
                class: "axxess-banner"
              }, null, 8 /* PROPS */, _hoisted_10)
            ], 8 /* PROPS */, _hoisted_9),
            _createElementVNode("button", {
              class: "banner-close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeBanner(_ctx.banner)))
            }, "X")
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.showChatTutorial)
      ? (_openBlock(), _createBlock(_component_ChatTutorial, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ]))
}